import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import WebApi from '../WebApi';
class WorkersWebApi extends WebApi {
    async getTechniciansData(payload, kind) {
        const sortBy = payload.sort ? `&sort=${payload.sort}` : '';
        const urlParams = `&pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sortBy}`;
        return axios.get(`${this.urlPrefix}/users?scope=${kind}${urlParams}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getAdvisorsData(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/advisors`, {
            'consult': true,
            'pagination[per_page]': payload.per_page,
            'pagination[page]': payload.current_page,
            'sort': payload.sort,
        });
        return axios.get(url);
    }
    async getAdvisorsDataBySearch(payload, searchValue, param) {
        const url = updateUrlGetParams(`${this.urlPrefix}/advisors`, {
            'last_name': searchValue,
            'consult': true,
            'pagination[per_page]': payload.per_page,
            'pagination[page]': payload.current_page,
            'sort': payload.sort,
        });
        return axios.get(url);
    }
    async getWorkerDataByAdvancedSearch(payload, customPayload, pageType, urlArrayString) {
        const url = updateUrlGetParams(`${this.urlPrefix}/searches/${pageType}`, {
            'pagination[per_page]': payload.per_page,
            'pagination[page]': payload.current_page,
            ...customPayload,
        });
        return axios.get(`${url}${urlArrayString}`);
    }
    async getWorkerAutocompleteSearch(payload, param, pageType) {
        const url = updateUrlGetParams(`${this.urlPrefix}/front_helpers/${pageType}${param}_autocomplete`, payload);
        return axios.get(url);
    }
    async getTechniciansDataBySearch(payload, searchValue) {
        const sortBy = payload.sort ? `&sort=${payload.sort}` : '';
        const userTechParams = `&pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sortBy}`;
        // eslint-disable-next-line
        const urlParams = payload.scope ? userTechParams + `&scope=${payload.scope}` : userTechParams;
        return axios.get(`${this.urlPrefix}/users?detail=${searchValue}${urlParams}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getManagersData(payload) {
        const urlParams = `&pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}`;
        return axios.get(`${this.urlPrefix}/users?scope=manager${urlParams}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getTechnicianData({ id }) {
        return axios.get(`${this.urlPrefix}/users/${id}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getTechnicianCaledarData({ id }) {
        return axios.get(`${this.urlPrefix}/remote_credentials?${id}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getAdvisorHelpersData() {
        return axios.get(`${this.urlPrefix}/components/advisor`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getTechnicianHelpersData() {
        return axios.get(`${this.urlPrefix}/components/technician`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async createWorker(payload) {
        return axios.post(`${this.urlPrefix}/users`, {
            'user': payload,
        });
    }
    async updateWorker(payload, id) {
        return axios.put(`${this.urlPrefix}/users/${id}`, {
            'user': payload,
        });
    }
    async updateWorkerAvailabilityType(payload, id) {
        return axios.put(`${this.urlPrefix}/users/${id}/set_availability_type`, {
            'user': payload,
        });
    }
    async updateManager(payload, id) {
        return axios.put(`${this.urlPrefix}/managers/${id}`, {
            'manager': payload,
        });
    }
    async createManager({ email, first_name, last_name, kind, role_id, role_name, phone }) {
        return axios.post(`${this.urlPrefix}/users`, {
            'user': {
                email,
                first_name,
                last_name,
                kind,
                role_id,
                role_name,
                phone,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async editWorker({ email, first_name, last_name, kind, company_id, color, add_travel_time, company_admin, phone }, workerId) {
        return axios.put(`${this.urlPrefix}/users/${workerId}`, {
            'user': {
                email,
                first_name,
                last_name,
                kind,
                company_id,
                color,
                add_travel_time,
                phone,
                company_admin,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async userToggleTravelTime({ user_id, toggle_travel_time }, workerId) {
        return axios.put(`${this.urlPrefix}/users/${workerId}/toggle_travel_time`, {
            'user': {
                user_id,
                toggle_travel_time,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async editManager({ email, first_name, last_name, kind, role_id, role_name, phone }, workerId) {
        return axios.put(`${this.urlPrefix}/users/${workerId}`, {
            'user': {
                email,
                first_name,
                last_name,
                kind,
                role_id,
                role_name,
                phone,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async deleteWorker({ id }) {
        return axios.delete(`${this.urlPrefix}/users/${id}`, {
            data: {},
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getTechnicianSchedulesData({ id }) {
        return axios.get(`${this.urlPrefix}/working_schedules/${id}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async editTechnicianSchedulesData(payload, id) {
        return axios.put(`${this.urlPrefix}/working_schedules/${id}`, {
            'working_schedule': payload,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async confirmTechnicianSchedulesData(payload, currentData, id) {
        payload.confirmed_at = currentData;
        return axios.put(`${this.urlPrefix}/working_schedules/${id}/confirm`, {
            'working_schedule': payload,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async confirmBranchSchedulesData(payload, id) {
        return axios.post(`${this.urlPrefix}/working_schedules`, {
            'working_schedule': { ...payload, 'site_id': id, 'confirmed_at': new Date() },
        });
    }
    async confirmAdvisorSchedulesData(payload, id) {
        return axios.post(`${this.urlPrefix}/working_schedules/bulk_create`, {
            'working_schedule': payload,
            'user_ids': [id],
        });
    }
    async confirmWorkerSchedulesData(payload, id) {
        return axios.post(`${this.urlPrefix}/working_schedules`, {
            'working_schedule': { ...payload, 'user_id': id, 'confirmed_at': new Date() },
        });
    }
    async confirmAdvisorsSchedulesData(payload) {
        return axios.post(`${this.urlPrefix}/working_schedules/bulk_create`, {
            'working_schedule': payload,
        });
    }
    async confirmAdvisorInvitationData(isAdvisorsAll, id) {
        const users = {
            'all': isAdvisorsAll,
            'user_ids': id,
        };
        return axios.post(`${this.urlPrefix}/users/bulk_invite`, { users });
    }
    async confirmAdvisorsAllInvitationData(isAdvisorsAll) {
        const users = {
            'all': isAdvisorsAll,
            'user_ids': [],
        };
        return axios.post(`${this.urlPrefix}/users/bulk_invite`, { users });
    }
    async getAdvisors(payload) {
        const sortBy = payload.sort ? `&sort=${payload.sort}` : '';
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sortBy}`;
        const { data } = await axios.get(`${this.urlPrefix}/advisors${urlParams}`);
        return data;
    }
    async updateTechnicianSchedulesData(payload) {
        return axios.post(`${this.urlPrefix}/update_requests`, {
            'update_request': payload,
        });
    }
    async deleteTechnicianUpdateData(id) {
        return axios.delete(`${this.urlPrefix}/update_requests/${id}`);
    }
}
const workersApi = new WorkersWebApi();
export { workersApi as WorkersWebApi, };
